import { withNamespaces } from 'react-i18next';

import CrewContainer from "./CrewContainer";

export default withNamespaces(['common'])(CrewContainer);
